<app-card
  *ngIf="detail"
  [cardBodyClasses]="'summary-detail-distributor__body'"
  [cardClasses]="'summary-detail-distributor__card mb-0'"
>
  <ng-container cardBody>
    <div class="summary-detail-distributor__row">
      <div class="summary-detail-distributor__col">
        <span class="summary-detail-distributor__label">Total Nilai Invoice (SO)</span>
        <span class="summary-detail-distributor__value">{{ detail.total_invoice }}</span>
        <button
          *ngIf="hasInvoiceDetail"
          (click)="openInvoiceDetail.emit()"
          class="summary-detail-distributor__link"
          type="button"
        >
          Lihat Detail
        </button>
      </div>

      <div class="summary-detail-distributor__col">
        <span class="summary-detail-distributor__label">Target Program</span>
        <span class="summary-detail-distributor__value">{{ detail.target_program }}</span>
        <span *ngIf="hasLevel" class="summary-detail-distributor__sub">{{
          detail.current_level
        }}</span>
      </div>

      <div class="summary-detail-distributor__col">
        <span class="summary-detail-distributor__label">Progres Program</span>
        <span class="summary-detail-distributor__value">{{ detail.progress_percentage }}</span>
        <span *ngIf="showProgressRatio" class="summary-detail-distributor__sub">
          {{ detail.current_progress }}
          <span class="summary-detail-distributor__sub--muted">/ {{ detail.target_progress }}</span>
        </span>
      </div>
    </div>

    <div class="summary-detail-distributor__divider"></div>

    <div class="summary-detail-distributor__row">
      <div class="summary-detail-distributor__col">
        <span class="summary-detail-distributor__label">Hadiah Didapatkan Distributor</span>
        <!-- [MAI-2725] Nama hadiah dan keterangan kelipatan dipisah: hanya nama yang dipotong
             ellipsis, "(Didapatkan Nx)" selalu utuh dengan style Body 2 abu-abu.
             Tooltip dinonaktifkan selama nama masih muat, supaya hover pada nama pendek
             tidak memunculkan popover. Isi tooltip hanya `rewardName` — "(Didapatkan Nx)"
             tidak pernah terpotong jadi mengulangnya di tooltip cuma duplikasi. -->
        <div class="summary-detail-distributor__reward">
          <span
            #rewardText
            [disablePopover]="!isRewardTruncated"
            [ngbPopover]="rewardName"
            class="summary-detail-distributor__value summary-detail-distributor__value--truncate"
            container="body"
            placement="bottom"
            popoverClass="tooltip-info"
            triggers="mouseenter:mouseleave"
            >{{ rewardName }}</span
          >
          <span
            *ngIf="detail.current_reward_count"
            class="summary-detail-distributor__reward-count"
            >{{ detail.current_reward_count }}</span
          >
        </div>
        <button
          *ngIf="hasOtherRewards"
          (click)="openOtherRewards.emit()"
          class="summary-detail-distributor__link"
          type="button"
        >
          +{{ detail.other_reward_count }} Hadiah Lainnya
        </button>
      </div>

      <div class="summary-detail-distributor__col">
        <span class="summary-detail-distributor__label">Estimasi Budget Hadiah</span>
        <span class="summary-detail-distributor__value">{{
          amountOrDash(detail.reward_budget_estimation)
        }}</span>
      </div>

      <div class="summary-detail-distributor__col">
        <span class="summary-detail-distributor__label">%Budget Hadiah</span>
        <span class="summary-detail-distributor__value">{{
          amountOrDash(detail.reward_budget_percentage)
        }}</span>
      </div>
    </div>
  </ng-container>
</app-card>
